"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionsRegistryId = void 0;
exports.ExtensionsRegistryId = 0;
//# sourceMappingURL=ServiceRegistryUtil.js.map